import React, { useRef, useState, useEffect } from 'react';
import './BirthdayCard.css';
import GiftSelection from './GiftSelection';

const BirthdayCard = ({ name = 'Mekynzie' }) => {
  const audioRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);
  
  // Add effect to auto-hide GIF after 10 seconds
  useEffect(() => {
    let timer;
    if (showVideo) {
      timer = setTimeout(() => {
        setShowVideo(false);
      }, 10000); // 10 seconds
    }
    return () => clearTimeout(timer);
  }, [showVideo]);
  return (
    <div className="birthday-card-container">
      <audio ref={audioRef} src="/Maui.mp3" preload="auto" />
      
      {showVideo && (
        <div className="video-overlay">
          <div className="video-container">
            <button className="close-video" onClick={() => setShowVideo(false)}>×</button>
            <iframe 
              src="https://tenor.com/embed/3474307541559993588" 
              className="gif-animation" 
              frameBorder="0" 
              allowFullScreen
              title="Frieren Anime GIF"
            ></iframe>
          </div>
        </div>
      )}
      <h1 className="birthday-title">Happy Birthday, {name}!</h1>
      
      <div className="card-content">
        <h2 className="special-day">On Your Special Day</h2>
        
        <p className="wishes">
        It is such a pleasure to celebrate you today because you genuinely deserve all that life has to offer. Every space you walk into and every heart you touch is brightened by your warmth, kindness, and sincere compassion.
        </p>
        
        <p className="additional-wishes">
        The way you think and treat people is something that people really desire, and whoever wins your affection will know they're living something truly unique.
        </p>
        
        <p className="additional-wishes">
        I hope you have lots of joy, lots of adventures, and lots of reasons to smile this year. Continue to radiate your lovely light; simply by being who you are, you improve and brighten my world.
        </p>
        
        <p className="additional-wishes">
        I hope this year is as beautiful and wonderful as you are!
        </p>
        
        <p className="closing">
          Best wishes
        </p>
      </div>
      
      {/* Gifts Section */}
      <GiftSelection 
        audioRef={audioRef} 
        showVideo={showVideo}
        setShowVideo={setShowVideo}
      />
    </div>
  );
};

export default BirthdayCard;
